import React, { useEffect, useState } from "react";
import api, { formatINR } from "@/lib/api";
import { TrendingUp, ChevronDown, ChevronUp } from "lucide-react";

export default function GrowthDividendCard() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/growth-dividend/me").then((r) => setD(r.data)).catch(() => {}); }, []);

  if (!d || !d.enabled) return null;
  const est = d.estimate;
  return (
    <div className="bg-gradient-to-br from-emerald-950 to-emerald-900 text-white rounded-2xl p-6" data-testid="growth-dividend-card">
      <div className="flex flex-wrap items-start gap-4">
        <div className="flex-1 min-w-[220px]">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-amber-300">
            <TrendingUp className="w-4 h-4" /> Growth Dividend
          </div>
          <div className="font-display text-3xl font-black mt-2" data-testid="gd-card-estimate">
            {est ? formatINR(est.dividend) : "₹0"}
          </div>
          <div className="text-xs text-emerald-200 mt-1">
            {est
              ? <>Estimated this cycle ({d.cycle}) — {d.percentage}% of your lowest qualified leg <b className="text-white">{est.lowest_leg_name}</b> ({formatINR(est.lowest_leg_income)})</>
              : <>Not qualified yet this cycle — you need {d.min_legs}+ direct legs each doing {formatINR(d.min_leg_business)}+ business</>}
          </div>
          {d.cycle_paid && <div className="text-[11px] font-bold text-amber-300 mt-1">✓ This cycle has been paid out</div>}
        </div>
        <div className="text-right">
          <div className="text-[10px] font-bold uppercase text-emerald-300">Lifetime</div>
          <div className="font-display text-xl font-black font-mono" data-testid="gd-card-lifetime">{formatINR(d.lifetime)}</div>
          <div className="text-[10px] text-emerald-300 mt-1">{d.percentage}% · {d.frequency}</div>
        </div>
      </div>
      {(est?.legs?.length || d.history.length > 0) && (
        <button onClick={() => setOpen(!open)} className="mt-3 text-[11px] font-bold text-amber-300 inline-flex items-center gap-1" data-testid="gd-card-toggle">
          {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />} {open ? "Hide details" : "View details"}
        </button>
      )}
      {open && (
        <div className="mt-3 grid sm:grid-cols-2 gap-4 text-xs">
          {est?.legs?.length > 0 && (
            <div>
              <div className="text-[10px] font-bold uppercase text-emerald-300 mb-1.5">Your direct legs this cycle</div>
              {est.legs.map((l) => (
                <div key={l.user_id} className="flex items-center gap-2 py-1 border-b border-emerald-800/60">
                  <span className={l.qualified ? "text-white font-semibold" : "text-emerald-400"}>{l.name}</span>
                  {!l.qualified && <span className="text-[9px] bg-emerald-800 text-emerald-300 px-1.5 py-0.5 rounded-full">below minimum</span>}
                  <span className="ml-auto font-mono">{formatINR(l.income)}</span>
                </div>
              ))}
            </div>
          )}
          {d.history.length > 0 && (
            <div>
              <div className="text-[10px] font-bold uppercase text-emerald-300 mb-1.5">Dividend history</div>
              {d.history.map((h) => (
                <div key={h.id} className="flex items-center gap-2 py-1 border-b border-emerald-800/60">
                  <span className="font-mono">{h.cycle}</span>
                  <span className="text-emerald-300">{h.lowest_leg_name} · {h.percentage}%</span>
                  <span className="ml-auto font-mono font-bold text-amber-300">{formatINR(h.amount)}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
